import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Programme() {
    const { t } = useLang('ecocreditsday.pageTabs.tabB');

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.tab-programme', //触发元素
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            offset: 200, //从开始点滚动多少px触发,可为负数
            duration: 300, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.tab-programme .programme-msg', 0.5, {
            opacity: 1,
            ease: 'none',
        });
        sceneA1.setTween(tweenA1);

        controllerDay.addScene(sceneA1);
    }, []);

    return (
        <div className={`${styles.programme} tab-programme`}>
            <div className="programme-msg">
                <div className="sub-title">{t('programme.sub_title')}</div>
                <div className="title">{t('programme.title')}</div>
                <div className="desc">{t('programme.desc')}</div>
            </div>
        </div>
    );
}
